import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { MessageBox, Message } from 'element-ui'

const msgbox = MessageBox

const { alert, confirm } = msgbox

Vue.prototype.$msgbox = msgbox
Vue.prototype.$alert = alert
Vue.prototype.$confirm = confirm
Vue.prototype.$message = Message

const getToken = () => store.state.token

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,

  timeout: 30000
})

instance.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
instance.defaults.headers['Cache-Control'] = 'no-cache'

// 添加请求拦截器
instance.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error.response.data)
  }
)

// 添加响应拦截器
instance.interceptors.response.use(res => {
  const code = res.status
  if (code === 401) {
    Vue.prototype.$confirm(
      '登录状态已过期，您可以继续留在该页面，或者重新登录',
      '系统提示',
      {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }
    ).then(() => {
      store.dispatch('logout').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    })
  } else {
    return res.data
  }
},
err => {
  if (err && err.response) {
    if (err.response.status === 401) {
      Vue.prototype.$confirm(
        '登录状态已过期，您可以继续留在该页面，或者重新登录',
        '系统提示',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('logout').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      })
    }
  }
})

export default instance
